/*eslint-disable */

import {
  Carousel,
  Slide
} from 'vue-carousel';

import appFooter from '@/components/public/common/footer/';
import {
  bus
} from '@/main';
import welcome from '@/components/welcome-popup/index';

const $ = window.jQuery = require('jquery');




export default {
  name: 'testimonials',
  components: {
    Carousel,
    Slide,
    'app-footer': appFooter,
    'welcome-popup': welcome
  },
  props: [],
  data() {
    return {
      preloader: true,
      slickOptions: {
        slidesToShow: 1,
        // Any other options that can be got from plugin documentation
        paginationEnabled: false
      },
    }
  },
  computed: {

  },
  mounted() {
    bus.$emit('hideHeaderbtn', false);
    bus.$emit('showLoginbtn', true);
    bus.$emit('showRegisterbtn', true);
    bus.$emit('showHomeMenuBtn', true);
    bus.$emit('showQuizMenubtn', true);
    $(document).ready(function() {
      $('.tesimonial-item figure').on('click', function() {

        $('#overlay, body').addClass('show-overlay');
        $('#overlay img').attr('src', $(this).children('img').attr('src'));
        var getDivEq = $(this).attr("data-imgId");
        var getContent = $('#tesimonialDetil .testimonial-detailin').eq(getDivEq).html();
        $('#overlay .testimonailcontent').html(getContent);
      })

      $(document).click(function(event) {
        //if you click on anything except the modal itself or the "open modal" link, close the modal
        if (!$(event.target).closest(".tesimonial-item figure").length) {
          $('#overlay, body').removeClass('show-overlay');
        }
      });

      $(document).ready(function() {
        $('.testimonial-full .btn').on('click', function(e) {
          e.preventDefault();
          $('#overlay, body').removeClass('show-overlay');
        })
      })
    });
    this.Window_Loader()
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
  },
  methods: {
    Window_Loader() {
      setTimeout(() => {
        this.preloader = false;
        $('.app-loader').hide()
      }, 800);
    },
    next() {
      this.$refs.slick.next()
    },
    prev() {
      this.$refs.slick.prev()
    },
    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick()
    },
    getImgUrl(pic) {
      return require('@/assets/images/' + pic)
    }
  },
  beforeCreate: function() {
    $('body').addClass('testimonials public-route');
    document.title = ' Oddvega - Testimonials '
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('testimonials public-route');
    next();
  }
}